export const environment: Environment = {
  APIGEE_HOST_EXTERNAL: 'https://api.nationwide.com',
  API_GATEWAY_KEY: 'bqlGLWB2IoaH5TM57JRcu37G1N93srvH4x0RIJOq',
  DEV_PORTAL_APP_CONSUMER_KEY_FRONTEND: 'Ty99BL2SPCBGnuf8N9sctZ8PdG7BAd1h',
  EUA_HOST: 'https://api.identity.nationwide.com',
  FULLSTORY_ENABLED: true,
  IUNGO_PORTAL_URL: 'https://nationwide.iungoportal.com',
  LAUNCH_DARKLY_CLIENT_SIDE_ID: '68924b876eaaf10a9fe636f3',
  NAME: 'prod',
  SPLUNK_ENABLED: true,
};
